import { buildFilterMapping } from '@/components/AgGrid/helpers/filterHelpers';

// `bankFeedSetColumnFilter` — registered in `BankFeedGrid/gridComponents.ts`; shared
// across every BE column type that needs the custom autocomplete-backed set filter.
const BANK_FEED_SET_FILTER = { filter: 'bankFeedSetColumnFilter' };

// `customDateFilter` — the shared server-side date filter (`AgDateFilterBE`), registered
// in `BankFeedGrid/gridComponents.ts`. Mapped by column *type* `date`, not per-column:
// every BE date column (Transaction Date, Value Date, Exchange Rate Date, …) inherits it.
// BE drives visibility per column via `filter: true|false`, so columns it leaves `filter: false`
// stay unfiltered even though the mapping exists.
const filterMappingByColumnType = [
  { string: { filter: 'agTextColumnFilter' } },
  { account: BANK_FEED_SET_FILTER },
  { select: BANK_FEED_SET_FILTER },
  { transaction_status: BANK_FEED_SET_FILTER },
  { amount: { filter: 'agNumberColumnFilter' } },
  { date: { filter: 'customDateFilter' } },
];

export const filterMapping = buildFilterMapping(filterMappingByColumnType);
